<div [class]="wrapperCssClasses()">
  <ng-content></ng-content>
</div>
